import { defineComponent as _defineComponent } from 'vue'
import BaseButton from 'JS/components/BaseButton.vue';
import Icon from 'JS/components/Icon.vue';
import { computed } from 'vue';
import { IconSubset } from 'JS/constants/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselArrowButton',
  props: {
    direction: null,
    ariaLabel: null,
    hideWhenDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	direction: 'previous' | 'next';
	ariaLabel?: string;
	hideWhenDisabled?: boolean;
}



const arrow = computed((): IconSubset<'arrow-back' | 'arrow-forward'> => props.direction === 'previous'
	? 'arrow-back'
	: 'arrow-forward'
);

const ariaLabelValue = computed(() => props.ariaLabel || props.direction);

return { __sfc: true,props, arrow, ariaLabelValue, BaseButton, Icon }
}

})